import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const CheckboxIndeterminateIcon = ({ size = 'small' }: IconProps) => {
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            style={{ borderRadius: '4px' }}
        >
            <title>Checkbox Indeterminate</title>
            <g id="Plays" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="2.3-Plays-+-filters---BATS---filters" transform="translate(-1601.000000, -517.000000)">
                    <g id="Group" transform="translate(1601.000000, 517.000000)">
                        <rect id="Rectangle" fill="#0070C8" x="0" y="0" width="24" height="24" rx="4"></rect>
                        <rect id="Rectangle" fill="#FFFFFF" x="5" y="11" width="14" height="3" rx="1.5"></rect>
                    </g>
                </g>
            </g>
        </svg>
    );
};
